import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpSharp';
import Tooltip from '@mui/material/Tooltip';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTextInBold } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  helpIcon: {
    color: theme.palette.text.secondary,
    verticalAlign: 'middle'
  },
  tooltipList: {
    margin: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    listStyleType: 'disc'
  },
  tooltipItem: {
    margin: theme.spacing(0)
  }
}));

const useTooltipStyles = makeStyles(() => ({
  tooltip: {
    maxWidth: 'none !important'
  }
}));

const ClearAllocationCheckboxTooltip = () => {
  const classes = useStyles();
  const tooltipClasses = useTooltipStyles();

  const { formatMessage } = useIntl();

  const tooltipContent = useMemo(
    () => (
      <>
        <FormattedMessage id="setResourceAllocationDialog.clearAllocationCheckboxTooltip.description" />
        <ul className={classes.tooltipList}>
          <li className={classes.tooltipItem}>
            <FormattedMessage
              id="setResourceAllocationDialog.clearAllocationCheckboxTooltip.checked"
              values={getTextInBold()}
            />
          </li>
          <li className={classes.tooltipItem}>
            <FormattedMessage
              id="setResourceAllocationDialog.clearAllocationCheckboxTooltip.unchecked"
              values={getTextInBold()}
            />
          </li>
        </ul>
      </>
    ),
    [classes]
  );

  const tooltipAriaLabel = formatMessage({
    id: 'setResourceAllocationDialog.clearAllocationCheckboxTooltip.ariaLabel'
  });

  return (
    <Tooltip
      classes={tooltipClasses}
      enterTouchDelay={0}
      placement="top"
      title={tooltipContent}
    >
      <HelpIcon
        aria-label={tooltipAriaLabel}
        className={classes.helpIcon}
        role="img"
        tabIndex={0}
      />
    </Tooltip>
  );
};

export default ClearAllocationCheckboxTooltip;
